<template>
    <div>
    <div class="alert alert-warning" role="alert" v-if="isCorpoClinico">
      <strong>Aviso!</strong> A rede que você está vinculada não está ativa verifique com o administrador da sua rede
    </div>
    <div class="alert alert-warning" role="alert" v-else-if="rede && rede.status === 'PRE_CADASTRO'">
      <strong>Aviso!</strong> Sua rede não está ativa termine seu cadastro para que seja avaliado pelo administrador.
      <router-link :to="{name: 'PageDadosCredenciado'}" class="alert-link">Clique aqui</router-link> para terminar o cadastro
    </div>
    <div class="layout-w">
        <menu-admin v-if="rede || acessaMenuAdm"></menu-admin>
        <div v-if="!acessaMenuAdm && user.role === 'Administrador' && !rede" class="content-w">
          <div class="no-results">
              <div class="big-error-w" style="margin-bottom: 100px;">
                  <h4>
                    Defina a rede
                  </h4>
                  <div class="row">
                    <div class="col">
                      <list-rede-admin></list-rede-admin>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col m-2">
                      <small>OU</small>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col m-2">
                      <button type="button" class="btn btn-secondary btn-lg btn-block"
                        @click="menuAdmin">Menu Administrador</button>
                    </div>
                  </div>
              </div>
          </div>
        </div>
        <div v-else class="content-w">
          <transition name="content" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>
</template> 

<script>
import MenuAdmin from '@/components/pages/dashboard/MenuAdmin'
import ListRedeAdmin from '@/components/shared/listRedeAdmin'

export default {
  computed: {
    user () {
      return this.$store.getters.user
    },
    rede () {
      return this.$store.getters.rede
    },
    isCorpoClinico () {
      return this.$store.getters.user.role === 'CorpoClinico'
    },
    acessaMenuAdm () {
      return this.$store.getters.menuAdm === 'S'
    }
  },
  components: {
    'menu-admin': MenuAdmin,
    ListRedeAdmin
  },
  methods: {
    menuAdmin () {
      this.$store.dispatch('setMenuAdm', 'S')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/Dashboard.vue